import './ProductDetail.scss';
import Component from './ProductDetail.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
